export default __webpack_public_path__ + "static/media/july2023-2.6a0dfea2.jpg";